import React, { useContext } from 'react';
import { makeId } from '../../../utilities/idComponent';
import { Button } from '../Button';

import { DropdownContext } from './DropdownContext';

export type DropdownButtonProps = {
  Component?: 'button' | React.FunctionComponent;
  timeout?: number;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const DropdownButton = ({
  Component = Button,
  children,
  id,
  timeout = 500,
  ...props
}: DropdownButtonProps) => {
  const { buttonRef, onToggle, hideMenu } = useContext(DropdownContext);

  const onBlur = () => {
    setTimeout(hideMenu, timeout);
  };

  return (
    <Component
      {...props}
      id={makeId('list', undefined, id)}
      ref={buttonRef}
      onBlur={onBlur}
      onClick={onToggle}
    >
      {children}
    </Component>
  );
};

export default DropdownButton;
